import { useEffect, useRef } from "react";
import socket from "../socket";

/* =========================================================
   useSocket
   Central hook for subscribing to live Socket.IO events.

   The server emits two events (see services/notificationService.js):
     - "notification"       -> sent to a single user (notifyUser)
     - "admin_notification" -> broadcast to every Boss/Admin (notifyAdmins)

   Usage:
     useSocket("notification", (payload) => { ... });
     useSocket("admin_notification", (payload) => { ... });

   The hook (re)joins the user's socket room on mount so that
   components using it don't depend on App.js having run first.
========================================================= */
export default function useSocket(eventName, handler) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      socket.emit("join", userId);
    }

    if (!eventName) return undefined;

    const listener = (payload) => {
      if (handlerRef.current) handlerRef.current(payload);
    };

    socket.on(eventName, listener);

    return () => {
      socket.off(eventName, listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventName]);
}
